import { render, staticRenderFns } from "./forex-order-flow.vue?vue&type=template&id=2da134d2&scoped=true"
import script from "./forex-order-flow.vue?vue&type=script&lang=js"
export * from "./forex-order-flow.vue?vue&type=script&lang=js"
import style0 from "./forex-order-flow.vue?vue&type=style&index=0&id=2da134d2&prod&lang=css"
import style1 from "./forex-order-flow.vue?vue&type=style&index=1&id=2da134d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da134d2",
  null
  
)

export default component.exports